import React from "react";
import style from "../style/card.module.scss";

export default function Card({ children }) {
  return <div className={style["dashboard-page-card"]}>{children}</div>;
}
